import { Team } from "@finway-group/shared/lib/models"
import { Button, Col, PageHeader, Row } from "antd"
import TeamModal from "Components/modals/team.modal"
import React from "react"
import { Edit as EditIcon, Plus as PlusIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useModal } from "Shared/context/modal.context"
import { useTeams } from "Shared/hooks/team.hooks"

const TeamSettings = () => {
    const { t } = useTranslation()
    const { showModal } = useModal()
    const history = useHistory()

    const teamValues = useTeams(true)

    return (
        <div id="finway-expense-settings" className="w-full">
            <div className="md:hidden">
                <PageHeader
                    ghost={false}
                    onBack={() => history.push("/settings")}
                    title={<h2 className="mb-0">{t("label:teams")}</h2>}
                    extra={[
                        <div className="ml-10">
                            <Button onClick={() => showModal(TeamModal, false, { isShowing: true, teams: teamValues })}>
                                {teamValues.length > 0 ? <EditIcon /> : <PlusIcon />}
                            </Button>
                        </div>,
                    ]}
                />
            </div>

            <div className="flex-row justify-between mb-10 hidden md:flex xs:items-center">
                <h2 className="mb-0">{t("label:teams")}</h2>
                <div className="ml-10">
                    <Button onClick={() => showModal(TeamModal, false, { isShowing: true, teams: teamValues })}>
                        {teamValues.length > 0 ? (
                            <>
                                <EditIcon />
                                <span>{t("action:edit")}</span>
                            </>
                        ) : (
                            <>
                                <PlusIcon />
                                <span>{t("action:create")}</span>
                            </>
                        )}
                    </Button>
                </div>
            </div>

            <div>
                {teamValues.length === 0 ? (
                    <div className="text-text-dark p-10">{t("missing:no_team")}</div>
                ) : (
                    <div className="p-5 h-full">
                        <Row gutter={[16, 16]} className="font-bold">
                            <Col flex="auto" className="text-left self-center">
                                {t("label:team")}
                            </Col>
                        </Row>
                        {teamValues.map((team: Team, index: number) => (
                            <Row gutter={[16, 16]} key={index}>
                                <Col span={16} className="text-left self-center truncate">
                                    {team.teamName}
                                </Col>
                            </Row>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default TeamSettings
